import api from './api'
import { Notification } from '../types/notification'

export const notificationService = {
  getAll: async (userId: number, page = 0, size = 20) => {
    const response = await api.get<{ success: boolean; data: Notification[] }>('/notifications', {
      params: { userId, page, size },
    })
    return response.data.data
  },

  getUnread: async (userId: number, page = 0, size = 20) => {
    const response = await api.get<{ success: boolean; data: Notification[] }>('/notifications/unread', {
      params: { userId, page, size },
    })
    return response.data.data
  },

  getUnreadCount: async (userId: number) => {
    const response = await api.get<{ success: boolean; data: number }>('/notifications/unread/count', {
      params: { userId },
    })
    return response.data.data
  },

  markAsRead: async (id: number) => {
    const response = await api.put<{ success: boolean; data: null }>(`/notifications/${id}/read`)
    return response.data
  },

  markAllAsRead: async (userId: number) => {
    const response = await api.put<{ success: boolean; data: null }>('/notifications/read-all', null, {
      params: { userId },
    })
    return response.data
  },

  markAsReadByWorkOrder: async (workOrderId: number) => {
    const response = await api.put<{ success: boolean; data: null }>(`/notifications/work-order/${workOrderId}/read`)
    return response.data
  },
}
